import http from "../utils/http"

/**
 * 获取质量安全保证承诺书模板
 */
export function getQualitySafetyGuaranteeCommitment() {
    return http({
        url: "/api/config/qualitySafetyGuaranteeCommitment"
    })
}

/**
 * 提交商家入驻申请
 * @param {object} params 入驻申请信息
 */
export function submitShopApply(params) {
    return http({
        url: "/api/warehouse/merchantAudit",
        data: params,
        forceLogin: true
    })
}
